import React from 'react';
import styles from './TimeAndStatusConclusion.module.scss';
import RefreshIcon from '@material-ui/icons/Refresh';
import CheckIcon from '@material-ui/icons/Check';
import {IProduct} from 'data/interfaces/products';
import {IOrder} from 'data/interfaces/orders';
import {statusToText} from 'gui/components/listPage/components/ad/components/adStatus';
import {scrollToTop} from 'gui/components/scrollToTopExtended/ScrollToTopExtended';

interface IPurchaseFormProps {
  product?: IProduct;
  order?: IOrder;
  isProductOwner?: boolean;
  isOrderOwner?: boolean;
  loadProduct?: () => Promise<any>;
}

/* with white inner square
const TimeAndStatusConclusion = (props: IPurchaseFormProps) =>
  <div className={styles.saleConclusionBottom}>
    <div className={styles.topTitleContainer}>
      <RefreshIcon className={styles.icon} onClick={() => {
        props.loadProduct()
          .then(() => {
            scrollToTop();
          })
      }}/>
      <h3 className={styles.statusLabelText}>סטטוס</h3>
    </div>
    <div className={styles.innerSalesConclusion}>
      <div className={styles.status}>
        <CheckIcon className={styles.icon}/>
        {statusToText(props.product.status)}
      </div>
    </div>
  </div>;
*/
const TimeAndStatusConclusion = (props: IPurchaseFormProps) =>
  <div className={styles.saleConclusionBottom}>
    <div className={styles.topTitleContainer}>
      <RefreshIcon className={styles.icon} onClick={() => {
        props.loadProduct()
          .then(() => {
            scrollToTop();
          })
      }}/>
      <h3 className={styles.statusLabelText}> {statusToText(props.product.status)}</h3>
    </div>
  </div>;

TimeAndStatusConclusion.defaultProps =
  {
    product: {}
    ,
    order: {}
    ,
  };

export default React.memo(TimeAndStatusConclusion);
